import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Http, Response, Headers } from '@angular/http';
import { Observable, ReplaySubject } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import { cacheable, clearCache, headers, headersBlob } from '../util/rxjs-functions';
import { bObservableUsuario, ObservableLotacao } from '../util/observable-util';
import { Sistemas } from 'app/entity/enumeraveis';

@Injectable()
export class PadraoService {

  constructor(public http: Http, private bObservable: bObservableUsuario, private lotacaoService: ObservableLotacao) { }

  LimparCache = (key: string) => clearCache(key);

  Adicionar(route: string, obj: any): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}/${route}`, obj, headers()).map(res => <any>res.json());
  }
  Atualizar(route: string, obj: any, parcial?: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}`, obj, headers(parcial)).map(res => <any>res.json());
  }
  Deletar(route: string, id: number): Observable<any> {
    return this.http.delete(`${environment.apiEndpoint}/${route}/${id}`, headers()).map(res => <any>res.json());
  }
  DeletarLista(route: string, ids: number[]): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}/Deletarlista`, ids, headers()).map(res => <any>res.json());
  }
  AtualizarById = (route: string, id: number, cacheKey?: string, refresh: boolean = true) => cacheable(
    () => this.http.put(`${environment.apiEndpoint}/${route}/AtualizarById/${id}`, id, headers()).map(res => <any>res.json()),
    cacheKey,
    refresh
  )
  Obter = (route: string, id: number, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${id}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterAnexo = (route: string, id: number, key: string, classtype: string, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${classtype}/${id}/${key}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterCodigo = (route: string, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/codigo`, headers(filtro)).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )
  ListarTodos = (route: string, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/listarTodos`, headers(filtro)).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )
  ObterTodos = (route: string, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}`, headers(filtro)).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )
  FiltroPerfil(route: string, obj: any): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}/${route}`, obj, headers()).map(res => <any>res.json());
  }

  Filtro = (route: string, filtro: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}`, headers(filtro)).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )

  /**
   * Parte de auth abaixo:
   */
  Permissoes = (refresh: boolean = true) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/api/Autenticar/permissao`, headers()).map(res => {
      this.bObservable.setValue({ obj: res.json() });
      return res.json();
    }).catch(err => this.handleAuthError(err)),
    localStorage.getItem('token'),
    refresh
  );

  Lotacoes = (refresh: boolean = true) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/api/Autenticar/lotacao`, headers()).map(res => {
      this.lotacaoService.setLotacao({obj: res.json()});
      return res.json();
    }),
    localStorage.getItem('token'),
    refresh
  );
  ObterToken = (code: string, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.post(`${environment.apiEndpoint}/api/Autenticar/Token/${code}`, null).map(res => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterTokenDecodificado = (refresh: boolean = true) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/api/Autenticar/DecodeToken`, headers()).map(res => {
      return res.json();
    }),
    localStorage.getItem('token'),
    refresh
  );
  Logout = () => this.http.get(`${environment.apiEndpoint}/api/Autenticar/sair`, headers()).subscribe(res => {
    localStorage.clear();
    window.location.href = `${environment.apiEndpoint}/api/Autenticar/`;
  });

  ObterLogoLotacao = (route: string, id: string, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${id}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterCep = (route: string, id: string, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${id}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterExcel = (route: string, filtro: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http
      .post(`${environment.apiEndpoint}/${route}/`, filtro, headersBlob({ 'Content-Type': 'application/vnd.ms-excel' }))
      .map((res: Response) => res),
    cacheKey,
    refresh
  )
  ObterPdf = (route: string, filtro: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http
      .post(`${environment.apiEndpoint}/${route}/`, filtro, headersBlob({ 'Content-Type': 'application/pdf' }))
      .map((res: Response) => res),
    cacheKey,
    refresh
  )
  CriarNovaSimulacao(route: string, obj: any): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}/${route}/CriarNovaSimulacao`, obj,
    headers()).map(res => <any>res.json());
  }
  EncerrarSimulacao(route: string, idUsuarioSimulador: number): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}/encerrarSimulacao`, idUsuarioSimulador,
    headers()).map(res => <any>res.json());
  }
  ListarNotificacoes = (idLotacao: number, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/fila-notificacao/Notificacoes/${idLotacao}/${Sistemas.Acessos}`, headers()).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )

  private handleAuthError(erro: any): Observable<any> {
    if (erro.status === 403) {
      localStorage.removeItem("token");
      window.location.href = `${environment.apiEndpoint}/api/Autenticar/`;
      return Observable.of(false);
    }
    return Observable.throw(erro);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/padrao.service.ts